import {onDomReady} from "./observer.js";

class Profile {
    constructor() {
        this.options = {
            profileHeaderMore: '[data-profile-header-more]',
            profileHeaderMorePopup: '[data-profile-header-more-popup]',
            profileHeaderMoreOpened: '_opened',
            profileStatsButtons: '[data-stats-buttons]',
        };

        this.elements = {
            profileHeaderMoreElement: document.querySelector(this.options.profileHeaderMore),
            profileHeaderMorePopupElement: document.querySelector(this.options.profileHeaderMorePopup),
            profileStatsButtonsElement: document.querySelector(this.options.profileStatsButtons),
        };

        this.init();
    }

    debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }


    checkStickyPosition(element) {
        const rect = element.getBoundingClientRect();

        if (Math.abs(rect.bottom + 6 - window.innerHeight) <= 1) {
            element.classList.add('_sticky');
        } else {
            element.classList.remove('_sticky');
        }
    }


    init() {
        if (this.elements.profileHeaderMoreElement &&
            this.elements.profileHeaderMorePopupElement) {
            const profileHeaderMoreButton = this.elements.profileHeaderMoreElement;
            const profileHeaderMoreWindow = this.elements.profileHeaderMorePopupElement;
            profileHeaderMoreButton.addEventListener('click', () => {
                profileHeaderMoreButton.classList.toggle(this.options.profileHeaderMoreOpened);
            });
            profileHeaderMoreWindow.addEventListener('click', function (event) {
                event.stopPropagation();
            });

            let closeProfileHeaderMore;
            profileHeaderMoreWindow.addEventListener("mouseenter", () => {
                clearTimeout(closeProfileHeaderMore);
            });
            profileHeaderMoreWindow.addEventListener("mouseleave", () => {
                closeProfileHeaderMore = setTimeout(() => {
                    profileHeaderMoreButton.classList.remove(this.options.profileHeaderMoreOpened);
                }, 1100);
            });
        }

        if (this.elements.profileStatsButtonsElement) {
            const statsButtons = this.elements.profileStatsButtonsElement;
            this.checkStickyPosition = this.checkStickyPosition.bind(this);
            const debouncedCheckStickyPosition = this.debounce(() => this.checkStickyPosition(statsButtons), 30);
            this.checkStickyPosition(statsButtons);
            window.addEventListener('scroll', debouncedCheckStickyPosition);
        }
    }
}

onDomReady(() => {
    const header = new Profile();
}, false);